import { render, staticRenderFns } from "./StockConfigurationDepartmentSelector.vue?vue&type=template&id=76ebde55&scoped=true&"
import script from "./StockConfigurationDepartmentSelector.vue?vue&type=script&lang=js&"
export * from "./StockConfigurationDepartmentSelector.vue?vue&type=script&lang=js&"
import style0 from "./StockConfigurationDepartmentSelector.vue?vue&type=style&index=0&id=76ebde55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ebde55",
  null
  
)

export default component.exports
import {QItem,QItemSection,QBtn,QPopupProxy,QCard,QCardSection,QIcon,QField} from 'quasar'
component.options.components = Object.assign({QItem,QItemSection,QBtn,QPopupProxy,QCard,QCardSection,QIcon,QField}, component.options.components || {})
